import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const LEASING_INTEREST_TYPE_DETAIL_SAVED = gql`
  subscription leasingInterestTypeDetailSaved {
    leasingInterestTypeDetailSaved {
      interestTypeDetailId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
